/* Generated from Java with JSweet 2.3.7 - http://www.jsweet.org */
import { CombinedAllNodeVisitor } from '../../../combined/visitors/CombinedAllNodeVisitor';
import { IReferenceNode } from '../../../core/models/IReferenceNode';
import { Node } from '../../../core/models/Node';
import { INamed } from '../../../core/models/common/INamed';

/**
 * Collect all nodes representing reference objects. Those nodes
 * MUST implement {@link IReferenceNode} and {@link INamed}.
 * <p>
 * Warning: The nodes are not cloned, so modifying them would modify the original model.
 * You MUST clone them yourself before changing their state.
 * <p>
 * Do not reuse visitor instances for multiple traversals.
 * 
 * @author Jakub Senko <jsenko@redhat.com>
 * @class
 * @extends CombinedAllNodeVisitor
 */
export class ReferenceCollectionVisitor extends CombinedAllNodeVisitor {
    /*private*/ fullNodes : Array<IReferenceNode>;

    /*private*/ referencedNodes : Array<IReferenceNode>;

    /**
     * Visit a node.  This is a common method called for every node type.
     * 
     * @param {Node} node
     */
    visitNode(node : Node) {
        if(node != null && (node["__interfaces"] != null && node["__interfaces"].indexOf("io.apicurio.datamodels.core.models.IReferenceNode") >= 0 || node.constructor != null && node.constructor["__interfaces"] != null && node.constructor["__interfaces"].indexOf("io.apicurio.datamodels.core.models.IReferenceNode") >= 0)) {
            let refNode : IReferenceNode = <IReferenceNode><any>node;
            if(refNode.getReference() != null) /* add */(this.referencedNodes.push(refNode)>0); else /* add */(this.fullNodes.push(refNode)>0);
        }
    }

    /**
     * @return {*[]} An map of collected nodes that CONTAIN an actual reference string.
     */
    public getReferencedNodes() : Array<IReferenceNode> {
        return <any>(this.referencedNodes.slice(0));
    }

    /**
     * @return {*[]} An map of collected nodes that DO NOT CONTAIN an actual reference string,
     * i.e. full nodes.
     */
    public getFullNodes() : Array<IReferenceNode> {
        return <any>(this.fullNodes.slice(0));
    }

    constructor() {
        super();
        this.fullNodes = <any>([]);
        this.referencedNodes = <any>([]);
    }
}
ReferenceCollectionVisitor["__class"] = "io.apicurio.datamodels.openapi.visitors.dereference.ReferenceCollectionVisitor";
ReferenceCollectionVisitor["__interfaces"] = ["io.apicurio.datamodels.core.visitors.IVisitor","io.apicurio.datamodels.asyncapi.v2.visitors.IAai20Visitor","io.apicurio.datamodels.openapi.v3.visitors.IOas30Visitor","io.apicurio.datamodels.asyncapi.visitors.IAaiVisitor","io.apicurio.datamodels.openapi.v2.visitors.IOas20Visitor","io.apicurio.datamodels.openapi.visitors.IOasVisitor"];




